@if (mode === 'read') {
  <!-- Read-only summary -->
  @if (rows.length === 0) {
    <p>No parent/guardian information provided.</p>
  }
  @for (row of rows; track $index) {
    <div class="pg-read-block">
      <h3 class="sub-header">Parent/Guardian {{ $index + 1 }}</h3>
      @if (isNotApplicable($index)) {
        <div nz-row>
          <div nz-col nzSpan="8" class="ppl-read-label">Not Applicable</div>
        </div>
      } @else {
        <div nz-row>
          <div nz-col nzSpan="8" class="ppl-read-label">First Name</div>
          <div nz-col nzSpan="16">{{ row.get('fname')?.value }}</div>
        </div>
        <div nz-row>
          <div nz-col nzSpan="8" class="ppl-read-label">Middle Name</div>
          <div nz-col nzSpan="16">{{ row.get('mname')?.value }}</div>
        </div>
        <div nz-row>
          <div nz-col nzSpan="8" class="ppl-read-label">Last Name</div>
          <div nz-col nzSpan="16">{{ row.get('lname')?.value }}</div>
        </div>
        <div nz-row>
          <div nz-col nzSpan="8" class="ppl-read-label">Relationship to Participant</div>
          <div nz-col nzSpan="16">{{ row.get('relationToParticipant')?.value }}</div>
        </div>
        <div nz-row>
          <div nz-col nzSpan="8" class="ppl-read-label">Date of Birth</div>
          <div nz-col nzSpan="16">{{ row.get('dob')?.value }}</div>
        </div>
        <ppl-address [mode]="'read'" [is_permanent]="false" [data]="addressGroup($index)?.getRawValue()"></ppl-address>
      }
    </div>
  }
} @else {
  <div class="pg-edit" nz-form nzLayout="horizontal">
    @for (row of rows; track $index) {
      <div class="pg-row" [formGroup]="$any(row)">
        <div class="pg-row-header">
          <h3 class="sub-header">
            Parent/Guardian {{ $index + 1 }}@if (!isNotApplicable($index)) {<span class="required"> *</span>}
          </h3>
          @if ($index >= 2) {
            <button aria-label="Remove parent/guardian" nz-button nzType="default" class="remove-btn"
              [disabled]="readonly" (click)="removeParent($index)">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          }
        </div>

        @if (hasNotApplicable($index)) {
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label">Not Applicable</nz-form-label>
            <nz-form-control class="ppl-form-control">
              <span nz-tooltip
                [nzTooltipTitle]="parents.length > 2 ? 'Remove the additional parents/guardians before marking the second one Not Applicable.' : ''">
                <label nz-checkbox formControlName="notApplicable"
                  [nzDisabled]="isNotApplicableDisabled"
                  (nzCheckedChange)="onNotApplicableChange($index, $event)"></label>
              </span>
            </nz-form-control>
          </nz-form-item>
        }

        @if (!isNotApplicable($index)) {
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="pg-fname-{{$index}}" class="ppl-form-label">First Name <span>*</span></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <input nz-input formControlName="fname" id="pg-fname-{{$index}}" placeholder="First Name" maxlength="50"
                [ngClass]="{'error': errorFor($index, 'fname')}" />
              @if (errorFor($index, 'fname')) { <span class="pl-1 error-message">{{ errorFor($index, 'fname') }}</span> }
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="pg-mname-{{$index}}" class="ppl-form-label">Middle Name</nz-form-label>
            <nz-form-control class="ppl-form-control">
              <input nz-input formControlName="mname" id="pg-mname-{{$index}}" placeholder="Middle Name" maxlength="50"
                />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="pg-lname-{{$index}}" class="ppl-form-label">Last Name <span>*</span></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <input nz-input formControlName="lname" id="pg-lname-{{$index}}" placeholder="Last Name" maxlength="50"
                [ngClass]="{'error': errorFor($index, 'lname')}" />
              @if (errorFor($index, 'lname')) { <span class="pl-1 error-message">{{ errorFor($index, 'lname') }}</span> }
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label">Relationship to Participant <span>*</span></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <ppl-dropdown-select formControlName="relationToParticipant" [options]="relationshipOptions"
                [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" [placeholder]="'Select Relationship'"></ppl-dropdown-select>
              @if (errorFor($index, 'relationToParticipant')) { <span class="pl-1 error-message">{{ errorFor($index, 'relationToParticipant') }}</span> }
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label">Date of Birth <span>*</span></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <ppl-date-picker formControlName="dob" [showIcon]="true" placeholder="MM/DD/YYYY"
                dateFormat="mm/dd/yy" [readonlyInput]="false" [monthNavigator]="true" [yearNavigator]="true"
                [yearRange]="'1900:2050'" [iconDisplay]="'input'" [panelStyleClass]="'custom-calendar-panel'"
                [maxDate]="today" [styleClass]="errorFor($index, 'dob') ? 'error' : ''"></ppl-date-picker>
              @if (errorFor($index, 'dob')) { <span class="pl-1 error-message">{{ errorFor($index, 'dob') }}</span> }
            </nz-form-control>
          </nz-form-item>

          <ppl-address [addressForm]="$any(addressGroup($index))" [is_permanent]="false" [showPSD]="false"
            [isMandatory]="true" [mode]="readonly ? 'read' : 'edit'"
            [permanentValidationErrors]="addressErrorsFor($index)"></ppl-address>
        }
      </div>
    }

    @if (canAddParent) {
      <div class="add-btn">
        <ppl-button label="Add Parent/Guardian" icon="fa fa-plus" [customClass]="'ghost-button'"
          [iconPosition]="'left'" [disabled]="readonly" (click)="addParent()"></ppl-button>
      </div>
    }
  </div>
}

<!-- Declared outside the mode blocks: @if removes its contents from the view, which would leave the
     ViewChild TemplateRef undefined. -->
<ng-template #confirmDeleteDialog let-cancel="cancel">
  <p>Are you sure you want to remove {{ pendingDeleteName }}?
    @if (pendingDeleteIsSaved) {
      This will delete the saved parent/guardian record immediately.
    } @else {
      The details entered will be discarded.
    }
  </p>
</ng-template>
